import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterWithdrawalRequestView.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date selectable is today
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for selecting state
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for the state selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the state selection
                                {
                                    id: '',
                                    value: _('Todos'), // All states
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'), // Active state
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'), // Inactive state
                                },
                                {
                                    id: 'R',
                                    value: _('Rechazado'), // Rejected state
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'), // Pending state
                                },
                                {
                                    id: 'E',
                                    value: _('Eliminado'), // Deleted state
                                },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for selecting payment methods
                            name: 'PaymentMethods',
                            label: "<span class='icon-credit-card'></span>" + _('Formas de Pago'), // Label for payment methods
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for payment methods
                                {
                                    id: '0',
                                    value: _('Todos'), // All payment methods
                                },
                                {
                                    id: '1',
                                    value: _('Efectivo'), // Cash payment method
                                },
                                {
                                    id: '2',
                                    value: _('Cuenta Bancaria'), // Bank account payment method
                                },
                                {
                                    id: '3',
                                    value: _('Giro Bancario'), // Bank transfer payment method
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for IP address
                            name: 'Ip',
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'), // Label for IP address
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '), // Placeholder text
                        },
                        {
                            view: 'combo', // Combo box for selecting Bet Shop
                            name: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label for Bet Shop
                            hidden: !devConfig.getPermAction(
                                'filterByBetShop',
                                'Add', // Conditional visibility based on permissions
                            ),
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch Bet Shop data
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Populate combo with response data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for minimum value
                            name: 'ValueMinimum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'), // Label for minimum value
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for maximum value
                            name: 'ValueMaximum',
                            type: 'number',
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'), // Label for maximum value
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'), // Placeholder text
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear filters
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Button to submit filters
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to submit
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Call event with filter data
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear filters in popup
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear the popup form
                    },
                },
                {
                    view: 'button', // Button to submit filters in popup
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to submit
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter values from popup
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (profile.typeDate == 2) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Call event with filter data
                        $$('filterPopup').hide(); // Hide the popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filter sections
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
